import * as theme from '@zero/design-tokens/build/js/variables';
import styled from 'styled-components';
import DesignTokens from 'uol-host-react-ui/dist/shared/DesignTokens.styles';

interface TextProps {
    isTitle?: boolean;
}

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 5px;
    align-items: baseline;
    font-family: ${theme.ZrFontFamilyDigitalLight};

    p{
        line-height: 0px;
    }

    @media (max-width: 991px) { 
        flex-direction: column;
        align-items: center;
        padding: 1rem;

        button {
            margin-top: 0.5rem;
        }
    }
`;

export const Button = styled.button`
    font-family: ${theme.ZrFontFamilyDigitalLight};
    background-color: white;
    border: 1px solid ${DesignTokens.color.ghost_uh};
    width: 235px;
    height: 32px;
    border-radius: 5px;
    color: ${DesignTokens.color.ghost_uh};
    font-size: ${theme.ZrFontSizeMicro} !important;
    margin-left: 60px;
    font-weight: 400;    

    @media (max-width: 991px) { 
        margin-left: 0px;
    }

    :hover {
        background-color: ${DesignTokens.color.ghost_uh};
        color: white;
        border: none;
    }
`;

export const Title = styled.p<TextProps>`
    color: ${theme.ZrColorNeutralMedium03};
    font-size: ${theme.ZrFontSizeMicro} !important;
    font-family: ${theme.ZrFontFamilyDigitalLight};
`;

export const SelectedHardwareResume = styled(Title)`
    font-weight: 600;
    color: ${theme.ZrColorNeutralMedium01};

    @media (max-width: 991px) { 
        margin: 10px 0!important;
    }
`